import * as types from '../constants'

const defaultState = {
  planPermissions: [],
  error: null,
  loading: false,
  users: [],
}

export default (state = defaultState, action) => {

  var newState = {...state}

  switch (action.type){
    case types.GET_PLAN_PERMISSIONS_REQUEST:
      newState.loading = true;
      newState.error = null
      return newState;
    case types.GET_PLAN_PERMISSIONS_SUCCESS:
      newState.loading = false;
      newState.planPermissions = action.body;
      return newState;
    case types.GET_PLAN_PERMISSIONS_FAILURE:
      newState.loading = false;
      newState.error = action.body
      return newState;

    case types.UPDATE_PLAN_PERMISSIONS_REQUEST:
      newState.loading = true;
      newState.error = null
      return newState;
    case types.UPDATE_PLAN_PERMISSIONS_SUCCESS:
      newState.loading = false;
      newState.planPermission = action.body;
      return newState;
    case types.UPDATE_PLAN_PERMISSIONS_FAILURE:
      newState.loading = false;
      newState.error = action.body
      return newState;

    case types.GET_USER_PLAN_PERMISSION_MATRIX_VALUES_REQUEST:
      newState.loading = true;
      return newState;
    case types.GET_USER_PLAN_PERMISSION_MATRIX_VALUES_SUCCESS:
      newState.planPermissions = action.body.plan_permissions
      newState.users = action.body.users
      newState.loading = false;
      return newState;

    case types.GET_USER_PLAN_PERMISSION_MATRIX_VALUES_FAILURE:
      newState.loading = false;
      newState.error = action.body
      return newState;

    default:  return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/plan_permission.js